import * as React from "react";
import classNames from "classnames";
import { omit } from "lodash";
import { Spin } from "antd";
import { SpinProps } from "antd/es/spin/index";

type CenterSpinnerResult = SpinProps & {
  whitelabel?: boolean;
};

export const CenterSpinner: React.FC<CenterSpinnerResult> = (props) => {
  const { whitelabel } = props;
  const spinProps = omit(props, ["whitelabel"]);

  const classes = classNames("verticalCenterWrapper", {
    whitelabel: whitelabel,
  });

  return (
    <div className={classes} style={{ width: "100%" }}>
      <Spin {...spinProps} />
    </div>
  );
};
